// Copied from portal-frontend
export const parseApiError = (errors: APIError | undefined | null, key = 'error') => {
	if (errors && errors[key] && Array.isArray(errors[key])) return errors[key].join('\n');
};
